import { render, staticRenderFns } from "./SignForTheQuery.vue?vue&type=template&id=666d47ba&scoped=true"
import script from "./SignForTheQuery.vue?vue&type=script&lang=js"
export * from "./SignForTheQuery.vue?vue&type=script&lang=js"
import style0 from "./SignForTheQuery.vue?vue&type=style&index=0&id=666d47ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666d47ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('666d47ba')) {
      api.createRecord('666d47ba', component.options)
    } else {
      api.reload('666d47ba', component.options)
    }
    module.hot.accept("./SignForTheQuery.vue?vue&type=template&id=666d47ba&scoped=true", function () {
      api.rerender('666d47ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Report/SignForTheQuery.vue"
export default component.exports